








































































import { Component, Vue } from 'vue-property-decorator';

import * as STdata from '../data/data.json'

@Component
export default class AppStart extends Vue {
	parties: any = STdata.default.parties
}

